<div class="enhanced-committee-field-container">
  <!-- EDITABLE MODE -->
  <div *ngIf="canUpdate" class="editable-mode">
    <!-- Fixed Label with Modal Button -->
    <div class="committee-select-wrapper">
      <p class="committee-field-label">{{fieldLabel}}</p>
      <button type="button" class="committee-select-button" (click)="openSelectionModal()" [disabled]="!hasCommittees"
        aria-label="Open committee selection">
        <span class="button-text" *ngIf="!hasSelections">Select committees</span>
        <span class="button-text" *ngIf="hasSelections">Change selection</span>
        <ion-icon name="chevron-forward-outline" class="button-icon"></ion-icon>
      </button>
    </div>

    <!-- Selected Items Preview (Chips) -->
    <div class="committee-chips-container" *ngIf="hasSelections">
      <ion-chip *ngFor="let committee of getSelectedCommittees()" class="committee-chip"
        [attr.aria-label]="'Remove ' + committee.name">
        <ion-label>{{committee.name}}</ion-label>
        <ion-icon name="close-circle" (click)="removeCommittee(committee.id)" class="chip-close-icon"></ion-icon>
      </ion-chip>

      <button type="button" class="btn-clear-all" (click)="clearAllCommittees()" aria-label="Clear all committees">
        <ion-icon name="close-circle-outline"></ion-icon>
        Clear all
      </button>
    </div>

    <!-- Empty State (No Selections) -->
    <div class="committee-empty-state" *ngIf="!hasSelections">
      <ion-icon name="layers-outline" class="empty-icon"></ion-icon>
      <p class="empty-text">No committees selected</p>
    </div>

    <!-- No Committees Available Warning -->
    <div class="committee-warning" *ngIf="!hasCommittees">
      <ion-icon name="alert-circle-outline" class="warning-icon"></ion-icon>
      <p class="warning-text">No committees available for selection</p>
    </div>
  </div>

  <!-- READ-ONLY MODE -->
  <div *ngIf="!canUpdate" class="readonly-mode">
    <!-- Field Header -->
    <div class="field-header">
      <ion-icon name="layers-outline" class="header-icon"></ion-icon>
      <span class="field-label">Committee</span>
      <span class="count-badge" *ngIf="hasSelections">{{selectedCount}}</span>
    </div>

    <!-- Selected Committees as Pills -->
    <div class="committee-pills-grid" *ngIf="hasSelections">
      <span class="committee-pill" *ngFor="let committee of getSelectedCommittees()">
        <ion-icon name="checkmark-circle" class="pill-icon"></ion-icon>
        {{committee.name}}
      </span>
    </div>

    <!-- Empty State (No Selections) -->
    <div class="committee-empty-readonly" *ngIf="!hasSelections">
      <ion-icon name="business-outline" class="empty-icon-readonly"></ion-icon>
      <p class="empty-text-readonly">No committees assigned</p>
    </div>
  </div>
</div>